import React, {Component} from "react";
import LastPosts from "../LastPosts/LastPosts";

import styles from "./Footer.module.scss";

class Footer extends Component {
    render() {
        return (
            <footer className={styles.fh5cofooter}>
                <div className="container">
                    <div className="row row-bottom-padded-md row-top-padded-md">
                        <div className="col-lg-3 col-md-6 col-12 animate-box">
                            <div className={styles.fh5cofooterwidget}><h3>Société</h3>
                                <ul className={styles.fh5colinks}>
                                    <li>
                                        <a href="/about" title="A propos d'integral service">Qui sommes nous</a>
                                    </li>

                                    <li>
                                        <a href="/services" title="Les services d'integral Service">Nos services</a>
                                    </li>
                                    <li>
                                        <a href="/blog" title="Les actualités du Web chez Integral Service">Le blog</a>
                                        
                                    </li>
                                    <li>
                                        <a href="/realisation" title="Les réalisations Integral Service">Références</a>
                                    </li>
                                    <li>
                                        <a href="/technologies-web" title="Les technologies web chez Integral Service">Technologies</a>
                                    </li>
                                    <li>
                                        <a href="/contact" title="Contacter Integral Service">Nous contacter</a>
                                    </li>
                                    <li>
                                        <a href="/ml" title="Contacter Integral Service">Mentions légales</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 animate-box">
                            <div className={styles.fh5cofooterwidget}><h3>Notre expertise</h3>
                                <ul className={styles.fh5colinks}>
                                    <li>
                                        <a href="/application-web" title="Les applications Web">Application Web</a>
                                    </li>
                                    <li>
                                        <a href="/portail-web-collaboratif" title="Réalisation de portails">Portail Intranet / Extranet</a>
                                    </li>
                                    <li>
                                        <a href="/application-iot" title="Applications pour objets connectés">Application IoT</a>
                                    </li>
                                    <li>
                                        <a href="/application-mobile" title="Applications mobile">Application mobile</a>
                                    </li>
                                    <li>
                                        <a href="/site-internet" title="Développement de site vitrine">Site vitrine</a>
                                    </li>
                                    <li>
                                        <a href="/e-commerce" title="Conception de site e-commerce">Site E-Commerce</a>
                                    </li>
                                    <li>
                                        <a href="/expert-symfony" title="Conception d'application Symfony">Symfony</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 animate-box">
                            <div className={styles.fh5cofooterwidget} itemScope itemType="http://schema.org/Person">
                                <h3>Nous contacter</h3>
                                <p>
                                    <a href="mailto:info@integral-service.fr" title="Adresse email" itemProp="email">info@integral-service.fr</a>
                                    <br/><span itemProp="name">INTEGRAL SERVICE</span><br/><span itemProp="streetAddress">36 Rue Emile Decorps, Bâtiment 23</span><br/><span itemProp="postalCode">69100</span> <span itemProp="addressLocality">Villeurbanne, France</span><br/>
                                    <a href="tel:0437697209" itemProp="telephone" title="Appeler Integral Service">+33 (0)4 37 69 72 09</a>
                                </p>
                                <ul className={styles.fh5colinks}>
                                    <li>
                                        <a href="/Offre-emploi" title="Découvrez les offres d'emploi Web et mobile"><strong>Recrutement & Offres d'emploi</strong></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 animate-box">
                            <div className={styles.fh5cofooterwidget}><h3>Nous suivre</h3>
                                <ul className={styles.fh5cosocial}>
                                    <li>
                                        <a href="https://twitter.com/IntegralWeb69" target="_blank" title="Suivre Integral Service sur Twitter">
                                            <i className="icon-twitter"/></a>
                                    </li>
                                    <li>
                                        <a href="https://www.facebook.com/integralweb69" title="Suivre Integral Service sur Facebook" target="_blank">
                                            <i className="icon-facebook"/></a>
                                    </li>
                                    <li>
                                        <a href="https://github.com/IntegralService" target="_blank" title="Suivre Integral Service sur Github">
                                            <i className="icon-github"/></a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/11263361/" target="_blank" title="Suivre Integral Service sur LinkedIn">
                                            <i className="icon-linkedin"/></a>
                                    </li>
                                    <li>
                                        <a href="https://www.integral-service.fr/rss.xml" target="_blank" title="Suivre le blog Web d'Integral Service">
                                            <i className="icon-rss"/></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.fh5cocopyright} animate-box`}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <p className={styles.fh5coleft}>
                                    <small>© 2017 &middot; Made with <span className={styles.badge}>fun</span> by <a href="/" title="Integral Service">Integral Service</a> Studio Web sur Lyon/Villeurbanne.</small>
                                </p>
                                <p className={styles.fh5coright}>
                                    <small className={styles.fh5coright}>Groupe <a href="https://www.integral-system.fr" title="Integral System" target="_blank">Integral System</a>.</small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx